import React from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
import Button from '../Button';
import { trackEvent } from '../../utils/analytics';
import s from './Bumper.module.scss';

const InfoModal = dynamic(() => import('../InfoModal'), {
  ssr: false,
});

const propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  location: PropTypes.string,
  cancel: PropTypes.string,
  btnLabel: PropTypes.string,
  isOpen: PropTypes.bool,
  link: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  eventName: PropTypes.string,
};

const defaultProps = {
  title: 'Thank you for visiting WizardingWorld.com',
  location: 'Leaving Wizarding World Bumper',
  description:
    'You are now leaving our website and heading to the Harry Potter and Fantastic Beasts shop which has a different privacy policy and terms of service, and is only suitable for over-13s.',
  btnLabel: 'CONTINUE',
  cancel: 'CANCEL',
  isOpen: false,
  eventName: '',
};

const Bumper = ({
  title,
  description,
  btnLabel,
  cancel,
  link,
  isOpen,
  onClose,
  eventName,
  location,
}) => (
  <InfoModal isOpen={isOpen} eventName={eventName} location={location} bumper toggleModal={onClose}>
    <div className={s.inner}>
      <h1 className={s.title}>{title}</h1>
      <div className={s.description}>{description}</div>
      <a
        href={link}
        className={s.link}
        onClick={() => {
          trackEvent(eventName, { location, cta_text: btnLabel });
          onClose();
        }}
      >
        <Button
          type="button"
          label={btnLabel}
          level="secondary2"
          theme="darkPurple"
          tabIndex="-1"
        />
      </a>
      <Button
        type="button"
        label={cancel}
        level="textLink"
        tabIndex="-1"
        onClick={() => {
          trackEvent(eventName, { location, cta_text: cancel });
          onClose();
        }}
      />
    </div>
  </InfoModal>
);

Bumper.propTypes = propTypes;
Bumper.defaultProps = defaultProps;
export default Bumper;
